<div class="p-dialog-header px-0">
  <div class="p-dialog-title">
    <div class="flex gap-spacing-xs align-items-center">
      <span class="title-small-bold text-primary-color">Passengers Equipments</span>
    </div>
  </div>
  <div class="p-dialog-header-icons">
    <app-button
      (click)="ref.close()"
      (keydown.enter)="ref.close()"
      [iconOnlyButton]="true"
      icon="icon-x"
      sizeClass="p-button-sm"
      severity="secondary"
      [textButton]="true"></app-button>
  </div>
</div>

<div class="flex flex-column gap-spacing-xs p-spacing-xl border-round-lg border-1 border-neutral-base-primary-border table-bg-hover-bg">
  <div class="table-section">
    @if (passengers.length > 0) {
    <app-basic-table [showIndex]="true" [tableData]="passengers | basicTable: 'passengers'"></app-basic-table>
    } @else {
    <app-data-not-found field="Passengers"></app-data-not-found>
    }
  </div>
</div>

<div class="p-dialog-footer pt-spacing-3xl px-0">
  <app-button
    label="Close"
    (click)="ref.close()"
    (keydown.enter)="ref.close()"
    sizeClass="p-button-md"
    severity="secondary"></app-button>
</div>
